import { VertAccordion, VertDropdown, VertTypography } from "@vertem-core/vertice-ds";
import isExternalLink from "Utils/isExternalLink";
import Icon from "components/Atoms/Icons/Icon";
import React from "react"
import { LuChevronDown, LuChevronUp } from "react-icons/lu";
import { useMediaQuery } from 'react-responsive';
import { Link } from "react-router-dom";

const accordionMenuItems = (items) => {
    return (
        <div className="content-content-items">
            {items.map((item) => {
                if ( item?.label ) {
                    return (
                        <VertTypography.Paragraph className="accordion-item" key={item.key}>
                            { item.label }
                        </VertTypography.Paragraph>
                    )
                }
            }
            )}
        </div>
    );
};


export const MenuItemRender = ( props ) => {
    const { label, path } = props
    const items = props?.items || [];

    const isLargeScreen = useMediaQuery({ minWidth: 769 });
    if (isLargeScreen) {
        if (items.length > 0) {
            //menu com submenu
            return (
                <VertDropdown className="vert-menu-item" title={label} template="marketplace" items={items} activeArrow />
            );
        } else if (path) {
            //so link
            return <VertTypography.Paragraph className="header-mobile-menu-items">
                { 
                isExternalLink(path) ?
                    (<a href={ path } target="_blank" rel="noreferrer" className='vert-menu-item link-external' data-label={ label }>
                        <VertTypography.Paragraph>{ label }</VertTypography.Paragraph>    
                    </a>)
                    : (
                    <Link to={path} className="vert-menu-item link-internal" data-label={ label }>
                        <VertTypography.Paragraph>{ label }</VertTypography.Paragraph>
                    </Link>
                    )
                }
            </VertTypography.Paragraph>        
        }
    } else {
        if (items.length > 0) {
            //menu com submenu
            return (
                <VertAccordion
                    size="small"
                    template="marketplace"
                    label={label}
                    className="header-mobile-menu-items"
                    iconOpen={<Icon className="lucide color-detached txt-balance-icon" size={`18px`} component={LuChevronDown} />}
                    iconClose={<Icon className="lucide color-detached txt-balance-icon" size={`18px`} component={LuChevronUp} />}
                >
                        { accordionMenuItems(items) }
                </VertAccordion>
                );
        } else if (path) {
            //menu só link
            return <VertTypography.Paragraph className="header-mobile-menu-items">
                { 
                isExternalLink(path) ?
                    <a href={ path } target="_blank" rel="noreferrer" className='link-external' data-label={ label }>{ label }</a>
                    : <Link to={ path } className='link-internal' data-label={ label }>{ label }</Link>
                }
            </VertTypography.Paragraph>        
        }
    }

}